import { SmartusComponentsModule } from '@affinis/smartus-components';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { IBooleanDialogData } from './booleanDialogData';

@Component({
  selector: 'app-boolean-dialog',
  templateUrl: './boolean-dialog.component.html',
  imports: [MatDialogModule, MatButtonModule, SmartusComponentsModule, TranslateModule],
})
export class BooleanDialogComponent {
  /**
   * Creates a new instance of BooleanDialogComponent.
   * @param data - Data to be passed to the dialog for displaying the message.
   */
  public constructor(@Inject(MAT_DIALOG_DATA) public data: IBooleanDialogData) {}
}
